import { formatBytes } from "@qoohoo/common/utils/string";
import * as Track from "@qoohoo/common/utils/analytics/track";

export default function FileCard({ url, mediaFileName, mediaFileSize }) {
  const formattedFileSize = formatBytes(mediaFileSize);

  function handleClick() {
    Track.linkClick("download_file", {
      url,
      mediaFileName,
      mediaFileSize,
    });
  }

  return (
    <a
      href={url}
      target="_blank"
      download
      className="min-w-max"
      onClick={handleClick}
    >
      <div
        key={url}
        className="flex justify-between items-center bg-[#2A3741] rounded-lg p-4"
      >
        <div className="flex items-center space-x-2">
          <img
            src="/assets/icons/paper.svg"
            alt="document"
            className="w-6 h-6 sm:w-8 sm:h-8"
          />
          <div>
            <h2 className="text-[13px] truncate max-w-[180px] sm:max-w-xs">
              {mediaFileName}
            </h2>
            <p className="mt-1 text-xs text-[#6A737C]">{formattedFileSize}</p>
          </div>
        </div>
        <img
          src="/assets/icons/download.svg"
          alt="download"
          className="w-6 h-6 sm:w-8 sm:h-8"
        />
      </div>
    </a>
  );
}
